import React from 'react'
import { Flex, Progress, Typography } from 'antd'

const { Text } = Typography

const StatisticsWithProgress = ({
    label,
    steps = 4,
    current = '...',
    total = '...',
    align = 'center',
    justify = 'center',
    style,
    title,
    size,
}) => {
    const percent = (current / total) * 100

    // Calculate step-based progress where steps only fill after thresholds are passed
    const calculateStepBasedPercent = (percent, steps) => {
        const stepSize = 100 / steps
        let filledSteps = 0
        
        // Count how many step thresholds have been passed
        for (let i = 1; i <= steps; i++) {
            const threshold = i * stepSize
            if (percent > threshold) {
                filledSteps = i
            }
        }
        
        // Return the percentage that represents the filled steps
        return (filledSteps / steps) * 100
    }

    const adjustedPercent = steps ? calculateStepBasedPercent(percent, steps) : percent

    return (
        <Flex vertical align={align} justify={justify} style={style} title={title}>
            <Text type='secondary'>{label}</Text>
            {total 
                ? <Progress 
                    percent={adjustedPercent} 
                    steps={steps} 
                    format={() => `${current}/${total}`} 
                    size={size}
                /> 
                : <Text style={{lineHeight: '1'}}>{current}</Text>
            }
        </Flex>
    )
}

export default StatisticsWithProgress
